import { dataGallerySolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGallerySolid = /*#__PURE__*/createIcon(dataGallerySolid)
export default IconGallerySolid
